var render = function () {
  var _vm$categoryFilter;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    staticClass: "card rounded-lg",
    style: {
      overflow: 'hidden'
    },
    attrs: {
      "color": _vm.cardColor,
      "tile": ""
    }
  }, [_c('v-card-title', [_c('a', {
    staticClass: "d-flex title-text align-center text-wrap",
    class: ((_vm.textColor) + "--text"),
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": "https://eastislip.librarycalendar.com/events/month",
      "target": "_blank"
    }
  }, [_c('v-icon', {
    attrs: {
      "color": _vm.textColor,
      "left": ""
    }
  }, [_vm._v("mdi-calendar")]), _c('h2', {
    staticClass: "text-h5 font-weight-black"
  }, [_vm._v("UPCOMING PROGRAMS")])], 1)]), _c('v-alert', {
    staticClass: "primary--text mx-4",
    attrs: {
      "value": _vm.showAlert,
      "border": "left",
      "dismissible": "",
      "type": "warning"
    }
  }, [_c('div', {
    staticClass: "font-weight-bold"
  }, [_vm._v("Please Note!")]), _c('div', [_vm._v("The library is transitioning to a new, improved program system.")]), _c('div', [_vm._v("Please use the old calendar for the following:")]), _c('div', {
    staticClass: "mt-2"
  }, [_vm._v("Adult & Teen programs for October.")]), _c('div', [_vm._v("Children's programs for October and November.")]), _c('v-btn', {
    staticClass: "mt-4",
    attrs: {
      "color": "primary",
      "href": "https://search.livebrary.com//iii/calendar/month/C&R=20",
      "target": "_blank"
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-calendar")]), _vm._v(" old calendar")], 1)], 1), !_vm.isLoading && _vm.showFilters ? _c('v-card-text', {
    staticClass: "d-flex align-center justify-center rounded-lg pa-4"
  }, [_c('v-sheet', {
    staticClass: "card-text d-flex align-center justify-start flex-wrap",
    staticStyle: {
      "overflow-y": "hidden"
    },
    attrs: {
      "color": "transparent",
      "width": "100%"
    }
  }, [_c('v-sheet', {
    staticClass: "d-flex flex-column align-start justify-start flex-wrap rounded-lg mb-4 pa-2",
    attrs: {
      "color": "secondary",
      "width": "100%"
    }
  }, [_c('v-sheet', {
    staticClass: "d-flex align-center mb-2",
    attrs: {
      "color": "transparent"
    }
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "color": "primary",
      "title": "Filter results by department"
    }
  }, [_vm._v("mdi-filter")]), _c('h3', {
    staticClass: "text-h6 font-weight-bold primary--text"
  }, [_vm._v("FILTERS")]), (_vm$categoryFilter = _vm.categoryFilter) !== null && _vm$categoryFilter !== void 0 && _vm$categoryFilter.length || _vm.searchInput ? _c('v-btn', {
    staticClass: "ml-2",
    attrs: {
      "color": "error",
      "dense": "",
      "text": "",
      "x-small": ""
    },
    on: {
      "click": _vm.clearFilters
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "error",
      "x-small": ""
    }
  }, [_vm._v("mdi-filter-remove")]), _vm._v(" Clear All")], 1) : _vm._e()], 1), _c('v-row', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "no-gutters": "",
      "align": "end",
      "justify": "space-between"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "xl": "12"
    }
  }, [_c('v-sheet', {
    staticClass: "d-flex flex-shrink-1",
    attrs: {
      "color": "transparent"
    }
  }, [_c('v-chip-group', {
    staticClass: "pa-0",
    attrs: {
      "multiple": ""
    },
    model: {
      value: _vm.categoryFilter,
      callback: function ($$v) {
        _vm.categoryFilter = $$v;
      },
      expression: "categoryFilter"
    }
  }, _vm._l(Object.entries(_vm.categoryColors), function (_ref) {
    var cat = _ref[0],
        color = _ref[1];
    return _c('v-chip', {
      key: cat,
      staticClass: "white--text font-weight-bold mr-4",
      attrs: {
        "value": cat,
        "color": color,
        "filter": ""
      }
    }, [_vm._v(" " + _vm._s(cat === 'children' ? 'KIDS' : cat.toLocaleUpperCase()) + " ")]);
  }), 1)], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "xl": "4"
    }
  }, [_c('v-sheet', {
    staticClass: "d-flex flex-grow-1 my-2 ml-auto",
    attrs: {
      "color": "transparent",
      "width": "auto"
    }
  }, [_c('v-text-field', {
    staticClass: "primary--text",
    attrs: {
      "clearable": "",
      "color": "primary",
      "dense": "",
      "hide-details": "",
      "prepend-inner-icon": "mdi-magnify",
      "outlined": "",
      "rounded": "",
      "solo": "",
      "type": "text"
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function () {
        return [_c('v-fade-transition', {
          attrs: {
            "leave-absolute": ""
          }
        }, [_vm.searchInput ? _c('v-btn', {
          attrs: {
            "color": "primary",
            "href": _vm.calendarSearchUrl(),
            "target": "_blank",
            "rounded": "",
            "small": ""
          }
        }, [_c('v-icon', {
          attrs: {
            "left": "",
            "small": ""
          }
        }, [_vm._v(" mdi-calendar-search-outline")]), _vm._v(" all ")], 1) : _vm._e()], 1)];
      },
      proxy: true
    }], null, false, 3261134146),
    model: {
      value: _vm.searchInput,
      callback: function ($$v) {
        _vm.searchInput = $$v;
      },
      expression: "searchInput"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e(), _c('v-card-text', {
    staticClass: "program-list transparent py-0 rounded-lg",
    attrs: {
      "id": "programlistCardText"
    }
  }, [_c('v-sheet', {
    staticClass: "rounded-lg",
    staticStyle: {
      "height": "100%"
    }
  }, [_vm.isLoading ? _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', {
    staticClass: "d-flex flex-column align-center justify-center"
  }, [_vm.isLoading ? _c('v-progress-circular', {
    staticClass: "mt-4",
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  }) : _vm._e(), _c('p', {
    staticClass: "text-h6 primary--text"
  }, [_vm._v("Getting upcoming programs...")])], 1)], 1) : !_vm.programsDisplayed.length ? _c('v-sheet', {
    staticClass: "primary--text font-weight-bold rounded-lg pa-4"
  }, [_c('p', [_vm._v(_vm._s(("No programs were found " + (_vm.categoryFilter.length || _vm.searchInput ? 'matching the applied filters ' : '') + "within the next 14 days.")))]), _c('v-btn', {
    staticClass: "mt-auto",
    attrs: {
      "color": "primary",
      "href": _vm.calendarSearchUrl(),
      "target": "_blank"
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-calendar-search")]), _vm._v("SEARCH ALL PROGRAMS ")], 1)], 1) : _c('v-list', {
    staticClass: "rounded-lg pb-8",
    class: _vm.showFilters ? 'mb-8' : '',
    attrs: {
      "dense": "",
      "color": "secondary",
      "two-line": "",
      "width": "100%"
    }
  }, [_vm._l(_vm.programsDisplayed, function (program) {
    return [_c('programListItem', {
      key: program.id,
      staticClass: "mb-2",
      attrs: {
        "id": 'program' + program.id,
        "item": program,
        "expanded": _vm.listItemExpanded === program.id
      },
      on: {
        "input": function ($event) {
          return _vm.onProgramItemInput(program);
        }
      }
    }), _c('v-divider', {
      key: ("d" + (program.id)),
      staticClass: "list-item-divider",
      attrs: {
        "color": "primary",
        "inset": ""
      }
    })];
  })], 2)], 1)], 1), _c('v-card-actions', {
    staticClass: "px-8 py-8"
  }, [_c('v-btn', {
    staticClass: "primary--text font-weight-bold rounded-lg",
    attrs: {
      "block": "",
      "large": "",
      "tile": "",
      "href": "https://eastislip.librarycalendar.com/events/month",
      "target": "_blank",
      "color": "secondary"
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-calendar-text")]), _vm._v("VIEW ALL PROGRAMS ")], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }